const memberSeoRoutesCore = require("./memberSeoRoutesCore.shared.js");

export const {
  MEMBER_SEO_CANONICAL_DECISIONS,
  MEMBER_SEO_DEFAULT_TASK_SLUG,
  MEMBER_SEO_ROUTE_PATTERN,
  MEMBER_SEO_TASKS,
  absoluteUrl,
  buildMemberSeoCityRoute,
  buildMemberSeoLocationContext,
  buildMemberSeoTaskRootRoute,
  citySlugFor,
  getMemberSeoCityBySlugs,
  getMemberSeoCityPath,
  getMemberSeoCityRouteBySlugs,
  getMemberSeoCityRoutes,
  getMemberSeoDiscoveryLinks,
  getMemberSeoRouteByPath,
  getMemberSeoRouteHero,
  getMemberSeoRoutes,
  getMemberSeoServiceRoute,
  getMemberSeoSignupPath,
  getMemberSeoStateBySlug,
  getMemberSeoTask,
  getMemberSeoTaskByProductAlias,
  getMemberSeoTaskRootPath,
  getMemberSeoTaskRootRoutes,
  getMemberSeoTaskSlugs,
  memberSeoCities,
  memberSeoCitiesByPath,
  memberSeoCitiesBySlug,
  memberSeoMetadata,
  memberSeoTaskByProductAlias,
  memberSeoStateGroups,
  memberSeoStatesBySlug,
  normalizePath,
  renderMemberSeoTemplate,
  stateSlugFor,
} = memberSeoRoutesCore;

export default memberSeoRoutesCore;
